const TooltipRenderer = function (params) {
    return params.value
        ? '<span title="' + params.value + '">' + params.value + '</span>'
        : null;
};

export default TooltipRenderer;
